import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

import { HotelViewModel } from 'models';

export interface SupportingMessagesProps {
  supportingMessages: HotelViewModel['supportingMessages'];
}

export const SupportingMessages: React.FunctionComponent<SupportingMessagesProps> = ({ supportingMessages }) => (
  <>
    <AbacusExperiment name="Dual_Price_TaxFeeIncluded_All_Searches">
      <AbacusControl>
        <RenderBoldSupportingMessages supportingMessages={supportingMessages} />
      </AbacusControl>
      <AbacusVariant bucket={1}>
        <div
          data-stid="supportingMessage-0"
          className="supporting-message including-tax uitk-cell pwa-theme--grey-700 uitk-type-right uitk-type-100"
        >
          {supportingMessages[0]}
        </div>
      </AbacusVariant>
      <AbacusVariant bucket={2}>
        <RenderBoldSupportingMessages supportingMessages={supportingMessages} />
      </AbacusVariant>
      <AbacusVariant bucket={4}>
        <RenderBoldSupportingMessages supportingMessages={supportingMessages} />
      </AbacusVariant>
    </AbacusExperiment>
  </>
);
const RenderBoldSupportingMessages = ({ supportingMessages }) => (
  <>
    {supportingMessages &&
      supportingMessages.length > 0 &&
      supportingMessages.map((supportingMessage, index) => (
        <div
          className={`supporting-message excluding-tax
               uitk-cell pwa-theme--grey-700 uitk-type-right uitk-type-100 ${index === 0 ? 'uitk-type-bold' : ''}`}
          key={`supportingMessage-${index}`}
        >
          {supportingMessage}
        </div>
      ))}
  </>
);
